export * from './event_view.component';